import { ChangeDetectionStrategy, Component, model, output } from '@angular/core';
import { input } from '@angular/core';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { IconComponent } from '../icon/icon.component';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'ca-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, IconComponent, MatPrefix, MatInput, MatSuffix]
})
export class SearchBoxComponent {
    placeholder = input<string>('');
    width = input<string>('auto');
    value = model<string>('');
    clear = output<void>();

    search(value: string) {
        this.value.set(value);
    }

    clearSearch() {
        this.value.set('');
        this.clear.emit();
    }
}
